import { MEDIA_QUERIES } from "@constants"
import styled from "styled-components"

export const CompetitorCalculatorSectionSECTION = styled.section`
  margin-bottom: var(--spacing--XL);

  .calculator {
    gap: var(--spacing--M) var(--spacing--L);
    flex-direction: column;
    align-items: center;
    padding: var(--spacing--M) 0;

    ${MEDIA_QUERIES.L} {
      align-items: flex-start;
      flex-direction: row;
      flex-wrap: nowrap;
    }
  }

  .controls {
    max-width: 494px;

    ${MEDIA_QUERIES.M} {
      flex: 0 0 40%;
      flex-wrap: nowrap;
    }

    h3 {
      margin-bottom: var(--spacing--M);
      font-size: var(--font-size--2XL);

      @media (min-width: 440px) {
        font-size: var(--font-size--3XL);
      }
    }

    .competitor-select {
      color: var(--color--action-default);
    }

    .form {
      display: flex;
      flex-wrap: wrap;
      gap: var(--spacing--XS) var(--spacing--base-1);

      input,
      select {
        font-family: var(--font-family--sans);
        font-feature-settings: var(--font-family--sans--font-feature-settings);
        font-size: var(--font-size--2XL);
        font-weight: var(--font-weight--light);
        letter-spacing: var(--letter-spacing--normal);
        line-height: var(--line-height--relaxed);
        margin-bottom: 0;
        text-transform: var(--text-transform--normal);
      }
    }

    label {
      flex: 0 0 calc(50% - var(--spacing--base-0-5));
      position: relative;

      &.full-width {
        flex: 0 0 100%;
      }

      span {
        display: block;
        font-size: var(--font-size--XS);
        margin-bottom: var(--spacing--base-0-5);
      }
    }
    
    .industry-select-wrapper .Icon {
      bottom: calc((var(--input--height-L) - 24px) / 2);
      left: var(--input--padding-x-L);
      pointer-events: none;
      position: absolute;
      z-index: 1;
    }

    .industry-select {
      padding-left: calc(var(--input--padding-x-L) + 26px);
    }

    .details {
      font-size: var(--font-size--XS);
      color: var(--color--text-light);
      font-style: italic;
    }
  }

  .comparison {
    --Plan--border-radius: var(--border-radius--M);
    --Plan--border-padding: 6px;
    --Plan--gradient-border-radius: calc(var(--border-radius--L) * 0.4);

    ${MEDIA_QUERIES.S} {
      display: flex;
      align-items: flex-start;
    }

    ${MEDIA_QUERIES.M} {
      max-width: 572px;
    }

    ${MEDIA_QUERIES.L} {
      flex: 0 0 calc(max(60%, calc(100% - 494px)) - var(--spacing--L));
      max-width: none;
    }

    .plan--hs {
      // Standard plan color
      --Plan--gradient-color: var(--color--green-100-rgb);
      --Plan--radial-gradient-color: var(--color--green-400-rgb);

      &.plan--plus {
        --Plan--gradient-color: var(--color--cobalt-100-rgb);
        --Plan--radial-gradient-color: var(--color--cobalt-400-rgb);
      }

      &.plan--pro {
        --Plan--gradient-color: var(--color--purple-100-rgb);
        --Plan--radial-gradient-color: var(--color--purple-400-rgb);
      }

      border-radius: var(--Plan--border-radius);
      background: var(--color--basics-white);
      border: 1px solid rgba(var(--color--cobalt-900-rgb), 0.08);
      box-shadow: var(--elevation--M);
      flex: 0 0 53%;
      height: 100%;
      padding: var(--spacing--base-2);
      position: relative;
      z-index: 2;

      &::before {
        content: "";
        display: block;
        background: linear-gradient(to right, rgb(var(--Plan--gradient-color)), rgb(var(--Plan--radial-gradient-color)));
        border-radius: var(--Plan--gradient-border-radius) var(--Plan--gradient-border-radius) 0 0;
        height: var(--Plan--border-padding);
        left: var(--Plan--border-padding);
        position: absolute;
        top: var(--Plan--border-padding);
        width: calc(100% - var(--Plan--border-padding) * 2);
      }

      &::after {
        background: linear-gradient(to top, rgba(var(--color--basics-white-rgb), 1) 10%, rgba(var(--color--basics-white-rgb), 0) 100%);
        bottom: 4px;
        content: "";
        display: block;
        height: 90%;
        left: 4px;
        position: absolute;
        width: calc(100% - 8px);
        z-index: 0;
      }

      .gradient-background {
        border-radius: var(--Plan--gradient-border-radius);
        height: 90%;
        left: var(--Plan--border-padding);
        opacity: 0.5;
        overflow: hidden;
        position: absolute;
        top: var(--Plan--border-padding);
        width: calc(100% - var(--Plan--border-padding) * 2);
        z-index: 0;

        &::before,
        &::after {
          content: "";
          display: block;
          background:
            url("/images/noise-overlay.png"),
            radial-gradient(circle at 100% 0%, rgba(var(--Plan--radial-gradient-color), 0.45) 0%, rgba(var(--Plan--radial-gradient-color), 0) 33.3333%),
            rgba(var(--Plan--gradient-color), 1);
          height: 100%;
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }

        &::before {
          border: 0.5px solid rgba(var(--color--cobalt-900-rgb), 0.05);
          z-index: 1;
        }

        &::after {
          background: linear-gradient(180deg, rgba(var(--color--basics-white-rgb), 0), rgba(var(--color--basics-white-rgb), 1));
          z-index: 2;
        }
      }

      .content {
        display: flex;
        flex-wrap: wrap;
        gap: var(--spacing--base-1-25);
        min-height: 100%;
        position: relative;
        z-index: 2;

        > * {
          flex: 0 0 100%;
        }

        p {
          text-wrap: balance;
          margin: 0;
        }
      }

      .plan-select {
        width: fit-content;

        .Icon {
          right: 0;
          background: var(--color--text-headline) !important;
        }
      }

      .Button {
        align-self: flex-end;
        width: 100%;
        margin-top: var(--spacing--S);
      }
    }

    .plan--competitor {
      border: 1px solid rgba(var(--color--cobalt-900-rgb), 0.08);
      border-top: none;
      box-shadow: var(--elevation--M);
      flex: 0 0 47%;
      padding: var(--spacing--base-2) var(--spacing--base-2) 0;
      position: relative;
      z-index: 1;

      ${MEDIA_QUERIES.S} {
        border-radius: 0 var(--Plan--border-radius) 0 0;
        border-top: 1px solid rgba(var(--color--cobalt-900-rgb), 0.08);
        border-left: none;
        margin-top: var(--spacing--S);

        .is-sales-page& {
          margin-top: 0;
        }
      }

      &::before {
        background: linear-gradient(
          to top,
          rgba(var(--color--basics-white-rgb), 1) 10%,
          rgba(var(--color--basics-white-rgb), 0.5) 60%,
          rgba(var(--color--basics-white-rgb), 0) 100%
        );
        bottom: -20px;
        content: "";
        display: block;
        height: 90%;
        left: -20px;
        position: absolute;
        width: calc(100% + 40px);
        z-index: 0;
      }

      .content {
        display: flex;
        flex-wrap: wrap;
        gap: var(--spacing--base-1-25);
        min-height: 100%;
        position: relative;
        z-index: 1;

        > * {
          flex: 0 0 100%;
        }
      }

      > * {
        flex: 0 0 100%;
      }

      p {
        text-wrap: balance;
        margin: 0;

        &.fine-print {
          align-self: flex-end;
          font-style: italic;
        }
      }
    }

    .plan-price {
      display: flex;
      align-items: center;
      gap: 4px;

      span {
        margin: 0;
      }

      .plan-price--mo {
        opacity: var(--opacity--60);
      }
    }
  }
`